import React, { useEffect, useRef } from "react";
import moment from "moment/moment";
export const setEdtailData = (appData, cardData) => {
  const storeCardata = {
    edetailId: cardData._id,
    slides: cardData.slides,
    cardData: cardData,
  };
  appData.setDeckId(storeCardata);
};

export const getEdtailData = (appData) => {
  let cardData = appData?.deckId;
  return cardData;
};

export const removeEdtailData = (appData) => {
  appData.setDeckId(null);
};

export const OutsideClickHandler = (ref, callback, when) => {
  const savedCallBack = useRef(callback);
  useEffect(() => {
    savedCallBack.current = callback;
  }, []);

  function handler(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      savedCallBack.current();
    }
  }

  useEffect(() => {
    if (when) {
      document.addEventListener("click", handler);
      return () => document.removeEventListener("click", handler);
    }
  }, [when]);
};

export const convertInDate = (date, formatType) => {
  if (date && formatType === "hrs") {
    return moment(date).format("DD/MM/YYYY hh:mm:ss");
  } else if (date && formatType === "normal") {
    return moment(date).format("DD/MM/YYYY");
  } else {
    return "-";
  }
};

export const daysAgoCreated = (createdDate, todaysDate)=>{
  const start = moment(createdDate)
  const todayDate = moment(new Date())
  const daysReturn = start.diff(todayDate, 'days').toString().substring(1);
  return (`${daysReturn> 0 ? daysReturn + `${daysReturn == 1?' day ago':' days ago'}` :'Today'}`)
}
